export default __webpack_public_path__ + "static/2-list-stores-9f1f9902018882057ce91df3a5c251bd.png";